import React from "react";
import { Check, X, Info } from "lucide-react";
import styles from "./styles.module.scss";
import Tooltip from "../Tooltip";
import { cn } from "@utils/utils";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";

interface FeatureItemProps {
  title: string;
  subtitle?: string;
  included?: boolean;
  tooltip?: string;
  className?: string;
}

export const FeatureItem: React.FC<FeatureItemProps> = ({
  title,
  subtitle,
  included = true,
  tooltip,
  className,
}) => {
  const Icon = included ? Check : X;

  return (
    <div className={cn(styles.feature, className)}>
      {/* <Icon
        size={16}
        className={cn(
          styles.feature__icon,
          included
            ? styles.feature__icon_included
            : styles.feature__icon_missing
        )}
      /> */}
      <Image
        src={
          included
            ? `${assetLoader()}/icons/Check_tick_correct.svg`
            : `${assetLoader()}/icons/CloseCross.svg`
        }
        alt={title}
        width={20}
        height={20}
      />
      <div className={styles.feature__content}>
        <div className={styles.feature__title}>
          {title}
          {tooltip && (
            <Tooltip content={tooltip}>
              <Info size={14} className={styles.feature__info} />
            </Tooltip>
          )}
        </div>
        {subtitle && <p className={styles.feature__subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
};
